// extracted by mini-css-extract-plugin
export default {"payment":"borrowingCapacityResultPay_payment__8rG77","label":"borrowingCapacityResultPay_label__ng68A"};